export default "__VITE_ASSET__D7vb3qgm__"